module.exports = __webpack_public_path__ + "static/img/portfolio5.c577930.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/portfolio5.jpg
// module id = AEJT
// module chunks = 0